import type {State} from 'src/reducers';
import type {
  AgentApiParams,
  ConnectionMetrics,
} from 'src/types/scheduler/global';


export const selectAgentApiParams = (state: State): AgentApiParams => {
  return state.scheduler.global.agentApiParams;
};

export const selectConnectionMetrics = (state: State): ConnectionMetrics => {
  return state.scheduler.global.connectionMetrics;
};

export const isConnectionLimitReached = (state: State): boolean => {
  const {maxConnections, activeConnections} = selectConnectionMetrics(state);
  return maxConnections <= -1 ? false : activeConnections >= maxConnections;
};
